const PAYMENT_METHOD_BRANDS = {
    amex: "American Express",
    diners: "Diners Club",
    discover: "Discover",
    eftpos_au: "Eftpos",
    jcb: "JCB",
    mastercard: "Mastercard",
    unionpay: "UnionPay",
    visa: "Visa"
};

export const formatPaymentMethodBrand = (value) => {
    const brand = value?.trim();
    if (!brand) return "Card";
    return PAYMENT_METHOD_BRANDS[brand.toLowerCase()]
        || `${brand.charAt(0).toUpperCase()}${brand.slice(1)}`;
};

export const formatSavedPaymentMethod = (method) => {
    const brand = formatPaymentMethodBrand(method?.brand);
    const expiry = method?.expiryMonth && method?.expiryYear
        ? `, expires ${String(method.expiryMonth).padStart(2, "0")}/${String(method.expiryYear).slice(-2)}`
        : "";
    return `${brand} ending in ${method?.lastFour || "••••"}${expiry}`;
};
